import React from 'react';
import Layout from '../components/App/Layout';
import Navbar from '../components/App/Navbar';
import PageBanner from '../components/Common/PageBanner';
import Footer from '../components/App/Footer';

const RefundPolicy = () => {
  return (
    <Layout title="Refund Policy">
      <Navbar />
      <PageBanner
        pageTitle="Refund Policy"
        homePageText="Home"
        homePageUrl="/"
        activePageText="Refund Policy"
      />
      <div className="ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="privacy-policy-content" style={{ lineHeight: '1.8', color: '#4a4a4a' }}>
                <p style={{ color: '#777', marginBottom: '40px' }}>
                  <em>Last updated: September 29, 2026</em>
                </p>

                <p>
                  This Refund Policy governs all engagements entered into with ByteForge (Pvt) Ltd
                  ("ByteForge", "we", "our", or "us"), a technology consultancy registered at 31-Q, Johar Town, Lahore, Pakistan. By engaging our services, you ("Client",
                  "you") acknowledge and agree to the terms set out below.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>1. General Policy</h3>
                <p>
                  Due to the professional, time-intensive, and customised nature of technology consultancy
                  services, all payments made to ByteForge are generally non-refundable once work has
                  commenced. However, we are committed to fairness and will evaluate refund requests on a
                  case-by-case basis in accordance with this policy.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>2. Deposits and Retainers</h3>
                <p>
                  Deposits or retainer fees paid to initiate a project are non-refundable. These payments
                  cover project planning, resource allocation, research, scoping, and initial work undertaken
                  by ByteForge prior to or at the commencement of the engagement.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>3. Milestone-Based Projects</h3>
                <p>
                  For projects structured around milestones, each milestone payment corresponds to a defined
                  set of deliverables. Payments for a milestone that has been completed and delivered are
                  non-refundable. If a Client wishes to cancel a project after a milestone payment has been
                  made but before work on that milestone has commenced, a partial refund may be considered,
                  minus any administrative and planning costs incurred.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>4. Client-Initiated Cancellation</h3>
                <p>
                  If a Client chooses to cancel a project after work has begun, the following applies:
                </p>
                <p>
                  The Client will be charged for all work completed up to the date of written cancellation
                  notice, calculated on a pro-rated basis or per the agreed milestone structure. Any
                  non-cancellable expenses incurred on the Client's behalf (such as third-party licences,
                  domain registrations, or API subscriptions) are non-refundable. A formal cancellation
                  request must be submitted in writing to{' '}
                  <a href="mailto:hello@byteforge.studio">hello@byteforge.studio</a>.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>5. ByteForge-Initiated Cancellation</h3>
                <p>
                  In the unlikely event that ByteForge is unable to continue or complete a project due to
                  circumstances on our end (excluding force majeure), we will refund a pro-rated amount
                  corresponding to work not yet completed, after deducting any expenses already incurred.
                  ByteForge will make commercially reasonable efforts to communicate this promptly and
                  to support a smooth transition.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>6. Dissatisfaction and Disputes</h3>
                <p>
                  If you are dissatisfied with any deliverable, we encourage you to raise your concerns
                  with us in writing at the earliest opportunity. ByteForge is committed to resolving
                  issues through revisions, remediation, or alternative solutions within the agreed scope.
                  Refunds will not be issued solely on grounds of dissatisfaction if the deliverables
                  meet the specifications agreed upon in the Statement of Work.
                </p>
                <p>
                  Where a genuine discrepancy exists between agreed specifications and delivered work,
                  ByteForge will first attempt to remedy the issue. If a remedy is not possible within
                  a reasonable timeframe, a partial or full refund for the affected portion of work
                  may be offered at ByteForge's discretion.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>7. Retainer and Subscription Services</h3>
                <p>
                  For ongoing retainer or subscription-based engagements, cancellation must be provided
                  in writing with a minimum of thirty (30) days' notice. Fees for the current billing
                  cycle are non-refundable. Upon cancellation, services will continue until the end of
                  the paid period.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>8. Refund Processing</h3>
                <p>
                  Where a refund is approved, it will be processed within fourteen (14) business days
                  using the original payment method wherever possible. ByteForge is not responsible for
                  any delays caused by banks or payment processors.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>9. Non-Refundable Items</h3>
                <p>
                  The following are non-refundable under any circumstances: initial deposits and
                  retainer fees; completed and accepted milestone payments; third-party costs incurred
                  on the Client's behalf; and consultation fees for advisory or strategy sessions
                  already conducted.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>10. Contact Us</h3>
                <p>
                  To submit a refund request or discuss a concern, please contact us:
                </p>
                <p>
                  <strong>ByteForge (Pvt) Ltd</strong><br />
                  31-Q, Johar Town, Lahore, Pakistan<br />
                  Email: <a href="mailto:hello@byteforge.studio">hello@byteforge.studio</a><br />
                  WhatsApp: <a href="https://wa.me/923043545344">+92 304 3545344</a>
                </p>
                <p>
                  We aim to respond to all refund-related enquiries within three (3) business days.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default RefundPolicy;
